import { render, staticRenderFns } from "./ShowUnitsModal.vue?vue&type=template&id=549a9ea9"
import script from "./ShowUnitsModal.vue?vue&type=script&lang=js"
export * from "./ShowUnitsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports